import React, { useEffect, useMemo, useState, useContext } from "react"
import { Card, CardContent, Box, Typography } from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import useStyles from "./styles"
import ExpenseTable from "../../Common/ExpenseTable/index"
import HeaderByLocation from "../../Common/HeaderByLocation/index"
import NoteBox from "../../Common/NoteBox/index"
import ExpenseTableTotal from "../../Common/ExpenseTableTotal/index"
import {
  toggleFlaggingDialog,
  toggleClickConfirmationDialog,
} from "../../../../actions/billingDialogs"
import { estimateCardBillingColumns } from "../../../../pages/Shoot/pages/Billing/BillingContext"
import { v4 as uuidv4 } from "uuid"
import isUuid from "../../../../utils/isUuid"
import calculateTotals from "../../../../utils/calculateTotals"
import markUpCalc from "../../../../utils/markUpCalc"
import { openSnackBar } from "../../../../actions/snack-bar"
import {
  updateExpense,
  updateExpenseFlagStatus,
  deleteExpense,
  deleteShootRoleCall,
  addDealMemoItem,
  createExpense,
  deleteDealMemoItem,
  reorderUsersRolesArray,
  updateItemsOrder,
} from "../../../../actions/billing"
import BillingContext from "../../../../pages/Shoot/pages/Billing/BillingContext"
import NoData from "../NoData/index"
import { mobileEstimateColumns } from "../../../../pages/Shoot/pages/Billing/BillingContext"
import useBillingDisabled from "../../../../hooks/useBillingDisabled"
import usePaidAmountEstimate from "../../../../hooks/usePaidAmountEstimate"

const EstimateCardBilling = props => {
  const classes = useStyles()

  const dispatch = useDispatch()
  const shootId = parseInt(props.match.params.shoot_id)
  const generalData = useSelector(state => state.billing.generalData)
  const billingContext = useContext(BillingContext)
  const { discount, estimate_note } = useSelector(
    state => state.billing.generalData
  )
  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)

  const [noteVal, setNoteVal] = useState("")
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth
  const isDisabled = useBillingDisabled()

  const paidAmt = usePaidAmountEstimate()

  const amounts = useMemo(
    () => {
      return calculateTotals(usersRolesArray, paidAmt, discount)
    },
    [usersRolesArray, paidAmt]
  )

  useEffect(
    () => {
      if (estimate_note !== null) {
        setNoteVal(estimate_note)
      }
    },
    [estimate_note]
  )

  // *** ADD BLANK ITEM  ***

  const addItem = role => {
    let newExpense = {
      expense_id: uuidv4(),
      shoot_id: Number(shootId),
      shootRoleId: role.id || role.shoot_role,
      user_id: role.user_id || null,
      type_name: "",
      item_type: null,
      quantity: 0,
      actual_rate: 0,
      client_rate: 0,
      discount: 0,
      description: "",
      is_percentage: 0,
      client_flag_status: "accepted",
    }
    billingContext.setUnsavedState(oldState => [
      ...oldState,
      `e${newExpense.expense_id}`,
    ])
    dispatch(addDealMemoItem(newExpense))
  }
  // *** ADD BLANK ITEM  END***

  // *** DELETE AN ITEM  ***

  const handleDelete = item => {
    if (billingContext.unsavedState.includes(`e${item.expense_id}`)) {
      billingContext.setUnsavedState(oldState => {
        return [
          ...oldState
            .map(x => {
              if (x !== `e${item.expense_id}`) {
                return x
              }
            })
            .filter(x => x),
        ]
      })
    }
    !isUuid(item.expense_id)
      ? dispatch(deleteExpense(item.expense_id, item.shoot_role))
        .then(() => {
          dispatch(openSnackBar({ message: "Expense item deleted" }))
        })
        .catch(err => {
          console.log(err)
          dispatch(openSnackBar({ message: "Error deleting item" }))
        })
      : dispatch(deleteDealMemoItem(item.expense_id, item.shoot_role))
  }

  const openDeleteConfirmation = (item, unsavedState) => {
    let data = {
      action: "delete this expense",
      confirmationFunc: handleDelete,
      funcArgs: [item, unsavedState],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }
  // *** DELETE AN ITEM  END***

  // *** DELETE SHOOT ROEL   ***
  const deleteShootRole = (shootRoleId, userId) => {
    dispatch(deleteShootRoleCall(shootRoleId, shootId, userId))
      .then(() => {
        dispatch(openSnackBar({ message: "User/role deleted" }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error deleting user/role" }))
      })
  }
  const openConfirmDialog = role => {
    let data = {
      action: "delete this role",
      confirmationFunc: deleteShootRole,
      funcArgs: [role.shoot_role || role.id, role.user_id],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }
  // *** DELETE SHOOT ROEL END  ***

  // *** RESOLVE FLAG   ***
  const resolveClientFlag = (nextStatusObj, expenseId) => {
    // statusCodeObj, itemId is the expense_id of the chosen expense
    let clientFlagStatus = {
      client_flag_status_id: nextStatusObj.client_flag_status_id,
      client_flag_comment: nextStatusObj.comment,
      shootRole: nextStatusObj.shootRole,
      type: "client",
    }
    // args come from Expense Table handleFlag fn, not from within this file
    dispatch(updateExpenseFlagStatus(clientFlagStatus, expenseId))
      .then(() => {
        dispatch(openSnackBar({ message: "Flag removed successfully" }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error removing flag" }))
      })
  }

  const handleFlagDialog = (nextStatus, item) => {
    // statusCodeObj { status_id: #}, itemId is the expense_id of the chosen expense
    // args come from Expense Table handleFlag fn, not from within this file
    const flagObj = {
      flagFunc: resolveClientFlag,
      nextStatus: { ...nextStatus, shootRole: item.shoot_role },
      comment: item.client_flag_comment,
      funcParams: [item.expense_id],
    }
    dispatch(toggleFlaggingDialog(true, flagObj))
  }
  // *** RESOLVE FLAG END  ***

  const handleSave = (values, actions, item, deal_memo_order, userId) => {
    if (billingContext.unsavedState.includes(`e${item.expense_id}`)) {
      billingContext.setUnsavedState(oldState => {
        return [
          ...oldState
            .map(x => {
              if (x !== `e${item.expense_id}`) {
                return x
              }
            })
            .filter(x => x),
        ]
      })
    }
    actions.setSubmitting(true)
    if (!isUuid(item.expense_id)) {
      let updateExpenseData = {
        expense_id: item.expense_id,
        type_name: values.type_name,
        item_type: values.item_type,
        quantity: values.quantity,
        actual_rate: values.actual_rate,
        client_rate: values.client_rate,
        discount: values.discount,
        is_percentage: values.is_percentage,
        description: values.description,
        deal_memo_order: deal_memo_order,
      }
      //update the server and redux
      dispatch(updateExpense(updateExpenseData, item.expense_id))
        .then(() => {
          dispatch(openSnackBar({ message: "Item updated" }))
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
        })
        .catch(err => {
          console.log(err)
          dispatch(openSnackBar({ message: "Error updating item" }))
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
        })
    } else if (isUuid(item.expense_id)) {
      let createdItem = {
        data: [
          {
            expense_id: item.expense_id,
            shoot_id: Number(shootId),
            shoot_role: item.shootRoleId,
            user_id: userId,
            type_name: values.type_name,
            item_type: values.item_type,
            quantity: values.quantity,
            actual_rate: values.actual_rate,
            client_rate: values.client_rate,
            discount: values.discount,
            is_percentage: values.is_percentage,
            description: values.description,
            deal_memo_order: deal_memo_order,
          },
        ],
      }
      dispatch(createExpense(createdItem))
        .then(() => {
          dispatch(openSnackBar({ message: "Item created" }))
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
        })
        .catch(err => {
          dispatch(openSnackBar({ message: "Error creating item" }))
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
        })
    }
  }

  const setItemsOrder = (newItemsArray, roleData) => {
    dispatch(
      reorderUsersRolesArray(
        newItemsArray,
        roleData.role.id || roleData.role.shoot_role
      )
    )

    let orderData = newItemsArray.map((item, index) => ({
      expenseId: item.expense_id ? item.expense_id : item.additional_expense_id,
      expenseType: item.expense_id ? "dmi" : "admi",
      order: index + 1,
    }))

    dispatch(updateItemsOrder(orderData))
  }

  return usersRolesArray.length === 0 ? (
    <NoData />
  ) : (
    <Card
      style={{
        padding: "15px",
      }}
    >
      <CardContent>
        <HeaderByLocation headerInfo={generalData} isDisabled={isDisabled} />
        <ExpenseTable
          columns={
            viewportWidth > 960
              ? estimateCardBillingColumns
              : mobileEstimateColumns
          }
          data={usersRolesArray}
        >
          <ExpenseTable.Header />
          <ExpenseTable.RoleGroup isDisabled={isDisabled}>
            <ExpenseTable.RoleBar showStatus={true}>
              <ExpenseTable.DeleteRoleButton onClick={openConfirmDialog} />
            </ExpenseTable.RoleBar>
            <ExpenseTable.ItemsGroup
              setItems={setItemsOrder}
              style={viewportWidth > 600 ? { marginLeft: 30 } : {}}
              draggable={true}
            >
              <ExpenseTable.ItemBar onSave={handleSave} isDisabled={isDisabled}>
                {/* name input */}
                <ExpenseTable.NameItem
                  style={
                    viewportWidth < 960
                      ? {
                        gridColumn: "1/ span 6",
                      }
                      : {}
                  }
                />
                {/* name input ends */}
                {/* quantity input  */}
                {viewportWidth > 960 ? (
                  <ExpenseTable.NumberItem valueForProperty="quantity" />
                ) : (
                  <Box
                    style={
                      viewportWidth < 600
                        ? {
                          gridRow: "3/3",
                          gridColumn: "type_name-start / actual_rate-start",
                        }
                        : {
                          gridRow: "3/3",
                          gridColumn: "1/1",
                        }
                    }
                  >
                    <Typography className={classes.mobileLabel}>Qty</Typography>
                    <ExpenseTable.NumberItem valueForProperty="quantity" />
                  </Box>
                )}
                {/* quantity input ends  */}
                {/* actual_rate input  */}
                {viewportWidth > 960 ? (
                  <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                ) : (
                  <Box
                    style={
                      viewportWidth < 600
                        ? {
                          gridRow: "3/3",
                          gridColumn: "actual_rate-start / discount-start",
                        }
                        : {
                          gridRow: "3/3",
                          gridColumn: "2/2",
                        }
                    }
                  >
                    <Typography className={classes.mobileLabel}>
                      Rate($)
                    </Typography>
                    <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                  </Box>
                )}
                {/* actual_rate input ends */}
                {/* client_rate input  */}
                {viewportWidth > 960 ? (
                  <ExpenseTable.NumberItem
                    valueForProperty="client_rate"
                    style={{ padding: 0 }}
                    InputProps={{
                      classes: {
                        adornedStart: classes.menuButton,
                        input: classes.menuInput,
                      },
                      startAdornment: <ExpenseTable.PercentageButton />,
                    }}
                  />
                ) : (
                  <Box
                    style={
                      viewportWidth < 600
                        ? {
                          gridRow: "3/3",
                          gridColumn: "discount-start / total-end",
                        }
                        : {
                          gridRow: "3/3",
                          gridColumn: "3/3",
                        }
                    }
                  >
                    <Typography className={classes.mobileLabel}>
                      Markup
                    </Typography>
                    <ExpenseTable.NumberItem
                      valueForProperty="client_rate"
                      InputProps={{
                        classes: {
                          adornedStart: classes.menuButton,
                          input: classes.menuInput,
                        },
                        startAdornment: <ExpenseTable.PercentageButton />,
                      }}
                    />
                  </Box>
                )}
                {/* client_rate input ends */}
                {/* discount input  */}
                {viewportWidth > 960 ? (
                  <ExpenseTable.NumberItem valueForProperty="discount" />
                ) : (
                  <Box
                    style={
                      viewportWidth < 600
                        ? {
                          gridRow: "4/4",
                          gridColumn: "type_name-start / actual_rate-start",
                        }
                        : {
                          gridRow: "3/3",
                          gridColumn: "4/4",
                        }
                    }
                  >
                    <Typography className={classes.mobileLabel}>
                      Discount($)
                    </Typography>
                    <ExpenseTable.NumberItem valueForProperty="discount" />
                  </Box>
                )}
                {/* discount input ends */}
                {/* total input  */}
                {viewportWidth > 960 ? (
                  <ExpenseTable.TotalItem>
                    {values =>
                      values.is_percentage
                        ? (
                          Number(values.actual_rate) *
                          Number(values.quantity) +
                          markUpCalc(
                            values.quantity * values.actual_rate,
                            values.client_rate
                          ) -
                          Number(values.discount)
                        ).toFixed(2)
                        : (
                          (values.quantity > 0
                            ? Number(values.client_rate)
                            : 0) +
                          (Number(values.actual_rate) *
                            Number(values.quantity) -
                            Number(values.discount))
                        ).toFixed(2)
                    }
                  </ExpenseTable.TotalItem>
                ) : (
                  <Box
                    style={
                      viewportWidth < 600
                        ? {
                          gridRow: "4/4",
                          gridColumn: "discount-start / total-end",
                        }
                        : {
                          gridRow: "3/3",
                          gridColumn: "6/6",
                        }
                    }
                  >
                    <Typography className={classes.mobileLabel}>
                      Total($)
                    </Typography>
                    <ExpenseTable.TotalItem justifyContent="center">
                      {values =>
                        values.is_percentage
                          ? (
                            Number(values.actual_rate) *
                            Number(values.quantity) +
                            markUpCalc(
                              values.quantity * (values.actual_rate || 0),
                              values.client_rate || 0
                            ) -
                            Number(values.discount)
                          ).toFixed(2)
                          : (
                            Number(values.client_rate) +
                            (Number(values.actual_rate) *
                              Number(values.quantity) -
                              Number(values.discount))
                          ).toFixed(2)
                      }
                    </ExpenseTable.TotalItem>
                  </Box>
                )}
                {/* total input ends */}
                {/* description input  */}
                <ExpenseTable.Item
                  valueForProperty="description"
                  style={
                    viewportWidth > 960
                      ? {
                        gridColumn: "type_name-start / quantity-start",
                        gridRow: "2/2",
                      }
                      : {
                        gridRow: "2/2",
                        gridColumn: "1/ span 6",
                      }
                  }
                />
                {/* description input ends */}
                {/* flag input  */}
                <ExpenseTable.FlagButton
                  hideIfNotFlagged
                  onClick={handleFlagDialog}
                />
                {/* flag input ends */}
                {/* save/delete buttons  */}
                <Box
                  style={
                    viewportWidth > 600
                      ? viewportWidth > 960
                        ? {
                          gridColumn: "quantity-start / total-end",
                          gridRow: "2/2",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          padding: "0 5px",
                        }
                        : {
                          gridColumn: "quantity-start / total-end",
                          gridRow: "4/4",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          padding: "0 5px",
                        }
                      : {
                        gridColumn: "quantity-start / total-end",
                        gridRow: "5/5",
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        padding: "0 5px",
                        marginBottom: "10px",
                      }
                  }
                >
                  <ExpenseTable.DeleteButton onClick={openDeleteConfirmation} />
                  <ExpenseTable.SaveButton />
                </Box>
                {/* save/delete buttons ends */}

                <Box
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: -8,
                    transform: "translateY(-10%)",
                  }}
                />
              </ExpenseTable.ItemBar>
            </ExpenseTable.ItemsGroup>
            <ExpenseTable.AddButton onClick={addItem} />
          </ExpenseTable.RoleGroup>
        </ExpenseTable>
        {/* Mobile View Swtich for the Message and the toal boxes */}
        {viewportWidth > 600 ? (
          <Box
            display="flex"
            justifyContent="space-between"
            style={{ marginTop: "40px" }}
          >
            <Box width="50%">
              <NoteBox
                noteVal={noteVal}
                setNoteVal={setNoteVal}
                shootId={shootId}
                isDisabled={isDisabled}
                {...props}
              />
            </Box>
            <Box width="50%" marginLeft="20%" marginRight="20px" flexShrink={1}>
              <ExpenseTableTotal
                data={amounts}
                addDiscount
                discount={discount}
              />
            </Box>
          </Box>
        ) : (
          <Box style={{ marginTop: "40px" }}>
            <Box width="100%">
              <NoteBox
                noteVal={noteVal}
                setNoteVal={setNoteVal}
                shootId={shootId}
                isDisabled={isDisabled}
                {...props}
              />
            </Box>
            <Box width="100%" flexShrink={1}>
              <ExpenseTableTotal
                data={amounts}
                addDiscount
                discount={discount}
                client={true}

              />
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}

export default EstimateCardBilling
